import React from 'react'
import { THEME, mapMediaDocToVideojsObject } from 'utils'
import VideoPlayerLite from 'components/VideoPlayerLite'

const VideoSection = ({ header, subheader, videos, brands, render }) => {
  return (
    <div className='videoSection'>
      <h2>{header}</h2>
      <h4>{subheader}</h4>
      {render ? (
        render(videos)
      ) : (
        <div className='videoSection__flex'>
          {videos.map(({ text, videoSource, img }, idx) => (
            <div className='videoSection__video' key={idx}>
              {videoSource ? (
                <VideoPlayerLite videoSource={mapMediaDocToVideojsObject(videoSource)} />
              ) : (
                <img src={img} alt={text + '_img'} />
              )}
              {text && <h5>{text}</h5>}
            </div>
          ))}
        </div>
      )}
      <h4 style={{ width: '100%', textAlign: 'center', color: '#000' }}>Your brand will be seen across:</h4>
      <div className='videoSection__brands'>
        {brands.map((brand, idx) => (
          <img key={idx} src={brand} alt={'brand_' + idx} />
        ))}
      </div>
      <style jsx>{`
        .videoSection {
          padding: 30px 24px;
        }
        .videoSection:nth-child(even) {
          background-color: #fff;
        }
        .videoSection h2 {
          margin: 0;
          font-size: 1.2rem;
        }
        .videoSection h4 {
          color: red;
          margin: 2px 0 0;
          font-size: 0.9rem;
        }
        .videoSection__flex {
          margin: 30px 0 0;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          flex-wrap: wrap;
        }
        .videoSection__video {
          width: 100%;
          margin-bottom: 25px;
        }
        .videoSection__video img {
          width: 100%;
        }
        .videoSection__video h5 {
          width: 100%;
          text-align: center;
          font-size: 0.8rem;
          font-style: italic;
          margin: 10px 0 0;
        }
        .videoSection__brands {
          margin-top: 10px;
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          align-content: space-around;
          justify-content: center;
        }
        .videoSection__brands img {
          border-radius: 20%;
          max-width: 80%;
          max-height: 35px;
          margin: 8px;
        }
        @media (min-width: ${THEME.BREAKPOINTS.XS}px) {
          .videoSection h2 {
            margin: 0;
            font-size: 0.95rem;
          }
          .videoSection h4 {
            font-size: 0.7rem;
          }
          .videoSection__flex {
            margin: 20px 0;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
          }
          .videoSection__video {
            width: ${videos ? 99 / videos.length : 100}%;
            max-width: 90%;
            margin: auto;
          }
          .videoSection__video img {
            width: 100%;
          }
          .videoSection__video h5 {
            font-size: 0.6rem;
            margin: 5px 0 0;
          }
          .videoSection__brands img {
            max-width: 100%;
            max-height: 30px;
            margin: 8px;
          }
        }
        @media (min-width: ${THEME.BREAKPOINTS.SM}px) {
          .videoSection {
            padding: 30px 40px;
          }
          .videoSection h4 {
            width: 85%;
          }
          .videoSection__brands img {
            margin: 8px;
          }
        }
        @media (min-width: ${THEME.BREAKPOINTS.MD}px) {
          .videoSection h2 {
            font-size: 1.1rem;
          }
          .videoSection h4 {
            font-size: 0.85rem;
          }
          .videoSection__flex {
            margin: 30px 0;
          }
          .videoSection__video h5 {
            font-size: 0.7rem;
          }
          .videoSection__brands img {
            margin: 10px;
            max-height: 35px;
          }
        }
        @media (min-width: ${THEME.BREAKPOINTS.XL}px) {
          .videoSection {
            padding: 30px 50px;
          }
          .videoSection h2 {
            font-size: 1.25rem;
          }
          .videoSection h4 {
            font-size: 1rem;
          }
          .videoSection__video h5 {
            font-size: 0.75rem;
          }
          .videoSection__brands img {
            max-height: 40px;
          }
        }
      `}</style>
    </div>
  )
}

export default VideoSection
